















import { computed, defineComponent, reactive, SetupContext } from '@vue/composition-api';

interface Props {
  confirmMessage: string;
  vModel?: boolean;
}

interface State {
  close: boolean;
}

const Component = defineComponent({
  name: 'ConfirmationWithoutActivator',

  props: {
    confirmMessage: String,
    vModel: Boolean,
  },

  setup(props: Props, { emit }: SetupContext) {
    const state = reactive({
      close: false,
    }) as State;

    const dialog = computed(() => (state.close ? false : props.vModel || false));

    function no() {
      state.close = true;
      emit('confirmed', false);
    }

    function yes() {
      state.close = true;
      emit('confirmed', true);
    }

    return {
      state,
      no,
      yes,
      dialog,
    };
  },
});

export default Component;
